export default "__VITE_ASSET__CEk5dFZ6__"